var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.2425V14.2425C2 15.0725 2.67 15.7425 3.5 15.7425C4.33 15.7425 5 15.0725 5 14.2425V10.2425C5 9.4125 4.33 8.7425 3.5 8.7425C2.67 8.7425 2 9.4125 2 10.2425ZM8 10.2425V14.2425C8 15.0725 8.67 15.7425 9.5 15.7425C10.33 15.7425 11 15.0725 11 14.2425V10.2425C11 9.4125 10.33 8.7425 9.5 8.7425C8.67 8.7425 8 9.4125 8 10.2425ZM1.5 20.7425H17.5C18.33 20.7425 19 20.0725 19 19.2425C19 18.4125 18.33 17.7425 17.5 17.7425H1.5C0.67 17.7425 0 18.4125 0 19.2425C0 20.0725 0.67 20.7425 1.5 20.7425ZM14 10.2425V14.2425C14 15.0725 14.67 15.7425 15.5 15.7425C16.33 15.7425 17 15.0725 17 14.2425V10.2425C17 9.4125 16.33 8.7425 15.5 8.7425C14.67 8.7425 14 9.4125 14 10.2425ZM8.57 0.2325L0.67 4.3925C0.26 4.6025 0 5.0325 0 5.4925C0 6.1825 0.56 6.7425 1.25 6.7425H17.76C18.44 6.7425 19 6.1825 19 5.4925C19 5.0325 18.74 4.6025 18.33 4.3925L10.43 0.2325C9.85 -0.0775 9.15 -0.0775 8.57 0.2325V0.2325Z",
    fill: "#BAB2C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.c822503e19a06341592468009b888a3d.svg";
export { ForwardRef as ReactComponent };